import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarriersListTabComponent } from './carriers-list-tab/carriers-list-tab';
import { CarrierChargesTabComponent } from './carrier-charges-tab/carrier-charges-tab';
import { ChargeTypesTabComponent } from './charge-types-tab/charge-types-tab';

@Component({
  selector: 'app-carriers-management-modal',
  standalone: true,
  imports: [CommonModule, CarriersListTabComponent, CarrierChargesTabComponent, ChargeTypesTabComponent],
  templateUrl: './carriers-management-modal.html',
  styleUrl: './carriers-management-modal.css'
})
export class CarriersManagementModalComponent implements OnInit {
  showModal = false;
  activeTab: 'carriers' | 'carrier-charges' | 'charge-types' = 'carriers';

  constructor() {}

  ngOnInit(): void {
    console.log('[CarriersManagementModal] Component initialized');
  }

  open(): void {
    this.showModal = true;
    console.log('[CarriersManagementModal] Modal opened');
  }

  close(): void {
    this.showModal = false;
    console.log('[CarriersManagementModal] Modal closed');
  }

  switchTab(tab: 'carriers' | 'carrier-charges' | 'charge-types'): void {
    this.activeTab = tab;
    console.log('[CarriersManagementModal] Switched to tab:', tab);
  }
}
